export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9689.ecb45986.jpg";